import { createRouter, createWebHistory } from 'vue-router'
import App from '@/App.vue'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: App
  },
  {
    path: '/theme-editor',
    name: 'ThemeEditor',
    component: () => import('@/components/ThemeGenerator/ThemeGenerator.vue'),
    beforeEnter: async (to, from, next) => {
      try {
        // Check with server if theme editor is enabled
        const response = await fetch('/api/theme-editor-access')
        const data = await response.json()

        if (data.enabled) {
          next() // Allow access
        } else {
          console.warn('[Theme Editor] Access denied: THEME_EDITOR not enabled')
          next({ name: 'Home' }) // Redirect to home
        }
      } catch (error) {
        console.error('[Theme Editor] Failed to check access:', error)
        next({ name: 'Home' }) // Fail closed - deny access on error
      }
    }
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router
